import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { ExistingSurveyableAsset } from "../../shared/interfaces/SurveyableAsset";

export function useSwitchgearUpdate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["switchgearUpdate"],
    async (switchgear: ExistingSurveyableAsset) => apiContext.hvSubstationApis.updateHvSurveyableAsset(switchgear),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
